import "../styles/steps.scss";
import { items } from "../services/data.ts";

const Steps = () => {
  return (
    <section id="steps" className="steps-section">

      <h2>As etapas de um serviço de manutenção completo</h2>

      <div className="step-grid">
        {items.steps.map((step, index) => (
          <div className="step-content">
            <img className={`step-image-outside ${index % 2 !== 0 ? 'right' : ''}`} src={step.image} />
            <div key={index} className="step-card">
              <h3>
                <div className="circle">{index + 1}</div>
                {step.title}
              </h3>
              <img className="step-image-inside" src={step.image} />
              <p>{step.desc}</p>
              <ul>
                {step.list.map((item, listIndex) => (
                  <li key={listIndex}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Steps;